interface offsetProps {
    top: number;
    left: number;
}

interface optionsProps {
    root: null | HTMLElement;
    rootMargin: string;
    threshold: number;
}

export default class Animation {
    static init(): void {
        this.handleParallax();
        this.handleObserveAnim();
        this.handleTechnologiesFixedBar();
        this.handleCountUpNumber();
    }

    static offset(el: HTMLElement): offsetProps {
        const rect = el.getBoundingClientRect(),
            scrollLeft = window.scrollX || document.documentElement.scrollLeft,
            scrollTop = window.scrollY || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    static parallaxSlow(parent: HTMLElement, children: HTMLElement): void {
        const parentOffset = this.offset(parent);
        const reversed = children.dataset.parallaxreversed;
        const horizontall = children.dataset.parallaxhorizontall;
        let negative = -1;

        if (reversed === 'true') {
            negative = 1;
        }

        if (horizontall) {
            if (horizontall === 'true') {
                if (window.matchMedia('(min-width: 1194px)').matches) {
                    const scroll = (window.scrollY - parentOffset.top) / (9 * negative);
                    children.style.transform = 'translateX(' + scroll + 'px)';
                }
            }
        } else {
            if (window.matchMedia('(min-width: 1599px)').matches) {
                const scroll = (window.scrollY - parentOffset.top) / (9 * negative);
                children.style.transform = 'translateY(' + scroll + 'px)';
            }
        }
    }

    static handleParallax(): void {
        const els: NodeListOf<HTMLElement> = document.querySelectorAll('.js-parallax');

        if (els.length > 0) {
            els.forEach((el: HTMLElement) => {
                const parent: HTMLElement | null = el.closest('.js-parallax-parent');

                if (parent) {
                    this.parallaxSlow(parent, el);
                }
            });
        }
    }

    static handleObserveAnim(): void {
        const els: NodeListOf<HTMLElement> = document.querySelectorAll('.js-animation');

        const options: optionsProps = {
            root: null, // The document viewport (default)
            rootMargin: '0px', // No offset from the root element (default)
            threshold: 0.3, // Call on 30% visibility
        };

        if (els.length > 0) {
            els.forEach((el: HTMLElement) => {
                Animation.setObserver(options, el);
            });
        }
    }

    static setObserver(options: optionsProps, element: HTMLElement): void {
        const observer = new IntersectionObserver((entries, observer) => {
            if (entries[0].intersectionRatio <= options.threshold) {
                return;
            }
            observer.disconnect();

            const target = entries[0].target;
            target.classList.add('js-animation-entered');
        }, options);

        observer.observe(element);
    }

    static handleTechnologiesFixedBar(): void {
        const barTrigger = <HTMLElement | null>document.getElementById('technologies-fixed-bar__trigger');
        const bar = <HTMLElement | null>document.getElementById('technologies-fixed-bar');

        if (bar && barTrigger) {
            const currentScrollPos = window.scrollY;
            if (currentScrollPos > 0) {
                bar.classList.add('technologies-fixed-bar--show');
            } else {
                bar.classList.remove('technologies-fixed-bar--show');
            }
        }
    }

    static handleCountUpNumber(): void {
        const objects: NodeListOf<HTMLElement> = document.querySelectorAll('.count-up-number-animation');
        if (objects.length > 0) {
            objects.forEach((obj: HTMLElement) => {
                const start = 0;
                const endString = obj.dataset.value;
                const durationString = obj.dataset.duration;
                if (
                    endString &&
                    durationString &&
                    !obj.classList.contains('count-up-number-animation--animated') &&
                    obj.closest('.js-animation-entered')
                ) {
                    const frameDuration = 1000 / 60;
                    const animationDuration: number = +durationString;
                    const totalFrames = Math.round(animationDuration / frameDuration);
                    const easeOutQuad = (t: number) => t * (2 - t);

                    const animateCountUp = (el: HTMLElement) => {
                        let frame = 0;
                        const countTo = parseInt(endString, 10);
                        const counter = setInterval(() => {
                            frame++;
                            const progress = easeOutQuad(frame / totalFrames);
                            const currentCount = Math.round(countTo * progress);

                            if (parseInt(el.innerHTML, 10) !== currentCount) {
                                el.innerHTML = numberWithSpaces(String(currentCount));
                            }

                            if (frame === totalFrames) {
                                clearInterval(counter);
                            }
                        }, frameDuration);
                        obj.classList.add('count-up-number-animation--animated');
                    };

                    animateCountUp(obj);
                }
            });
        }

        function numberWithSpaces(x: string) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
    }
}
